import { render } from "./Application.vue?vue&type=template&id=33b971e8"
import script from "./Application.vue?vue&type=script&lang=js"
export * from "./Application.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__